import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "./flags";

export async function asyncWithFeatureFlagProvider(clientSideId) {
  // Create our flag defaults object from the feature flag map.
  const flagDefaults = {};
  Object.values(FeatureFlags).forEach((featureFlag) => {
    flagDefaults[featureFlag.key] = featureFlag.default;
  });

  return asyncWithLDProvider({
    clientSideID: clientSideId,
    flags: flagDefaults,
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  });
}
